// TermsOfService.js
import React from "react";
import './TermsOfService.css';
import RectangularLogo from './rectangular-logo.png';

export default function TermsOfService() {
  return (
    <div className="terms-container">
      <main className="content">
        <img src={RectangularLogo} alt="SizzleWrap Logo" className="main-logo" />
        <h1 className="title">Terms of Service</h1>
        <p className="date"><strong>Effective Date:</strong> April 24, 2025</p>

        <section className="section">
          <h2>1. Introduction</h2>
          <p>Welcome to SizzleWrap (“we,” “us,” or “our”). By accessing or using our service, you agree to be bound by these Terms. If you do not agree, please do not use SizzleWrap.</p>
        </section>

        <section className="section">
          <h2>2. Data Deletion</h2>
          <p>If you would like your slideshow and any associated data deleted, please email <a href="mailto:help@sizzlewrap.ccom">help@sizzlewrap.ccom</a>.</p>
        </section>

        <section className="section">
          <h2>3. Acceptance of Terms</h2>
          <p>By signing up, you represent that you have the legal capacity to enter into this agreement. You agree to comply with all applicable laws and regulations.</p>
        </section>

        <section className="section">
          <h2>4. Use of Service</h2>
          <p>• You may use SizzleWrap to connect your Instagram account and generate a personalized slideshow.</p>
          <p>• You agree not to reverse engineer, misuse, or interfere with the operation of our service.</p>
        </section>

        <section className="section">
          <h2>5. Account Registration</h2>
          <p>You must provide a valid email address and must keep your account information accurate and up to date. You are responsible for all activities under your account.</p>
        </section>

        <section className="section">
          <h2>6. Fees and Payment</h2>
          <p>Use of the core SizzleWrap service is free. If we introduce any paid features, those will be clearly communicated and billed separately.</p>
        </section>

        <section className="section">
          <h2>7. Intellectual Property</h2>
          <p>All content, logos, and trademarks are owned by SizzleWrap or our licensors. You may not use our branding without permission.</p>
        </section>

        <section className="section">
          <h2>8. Termination</h2>
          <p>We may suspend or terminate your access at any time for violation of these Terms or for any other reason with or without notice.</p>
        </section>

        <section className="section">
          <h2>9. Disclaimers & Limitation of Liability</h2>
          <p>Our service is provided “as is.” We disclaim all warranties. In no event will we be liable for any indirect or consequential damages.</p>
        </section>

        <section className="section">
          <h2>10. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of New York, without regard to its conflict of laws principles.</p>
        </section>

        <section className="section">
          <h2>11. Changes to Terms</h2>
          <p>We may update these Terms periodically. We’ll post the new Effective Date here. Continued use after changes constitutes acceptance.</p>
        </section>

        <section className="section">
          <h2>12. Contact Us</h2>
          <p>If you have questions, contact us at <a href="mailto:help@sizzlewrap.com">help@sizzlewrap.com</a>.</p>
        </section>
      </main>

      <footer className="footer">
        &copy; 2025 SizzleWrap. All rights reserved.
      </footer>
    </div>
  );
}
